/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { HalJson } from '../models/hal-json';
import { PaginatedHalJson } from '../models/paginated-hal-json';
import { TaxIdMappingRule } from '../models/tax-id-mapping-rule';
import { taxIdMappingRulesGet } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-get';
import { TaxIdMappingRulesGet$Params } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-get';
import { taxIdMappingRulesIdDelete } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-delete';
import { TaxIdMappingRulesIdDelete$Params } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-delete';
import { taxIdMappingRulesIdGet } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-get';
import { TaxIdMappingRulesIdGet$Params } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-get';
import { taxIdMappingRulesIdPut } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-put';
import { TaxIdMappingRulesIdPut$Params } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-id-put';
import { taxIdMappingRulesPost } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-post';
import { TaxIdMappingRulesPost$Params } from '../fn/tax-id-mapping-rules/tax-id-mapping-rules-post';

@Injectable({ providedIn: 'root' })
export class TaxIdMappingRulesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taxIdMappingRulesGet()` */
  static readonly TaxIdMappingRulesGetPath = '/tax-id-mapping-rules';

  /**
   * Lists tax ID mapping rules.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxIdMappingRulesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesGet$Response(params: TaxIdMappingRulesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: PaginatedHalJson;
'_embedded'?: {
'taxMappingRule'?: Array<TaxIdMappingRule>;
};
'size'?: number;
'count'?: number;
'currentStart'?: string;
'nextStart'?: string;
}>> {
    return taxIdMappingRulesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Lists tax ID mapping rules.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxIdMappingRulesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesGet(params: TaxIdMappingRulesGet$Params, context?: HttpContext): Observable<{
'_links'?: PaginatedHalJson;
'_embedded'?: {
'taxMappingRule'?: Array<TaxIdMappingRule>;
};
'size'?: number;
'count'?: number;
'currentStart'?: string;
'nextStart'?: string;
}> {
    return this.taxIdMappingRulesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: PaginatedHalJson;
'_embedded'?: {
'taxMappingRule'?: Array<TaxIdMappingRule>;
};
'size'?: number;
'count'?: number;
'currentStart'?: string;
'nextStart'?: string;
}>): {
'_links'?: PaginatedHalJson;
'_embedded'?: {
'taxMappingRule'?: Array<TaxIdMappingRule>;
};
'size'?: number;
'count'?: number;
'currentStart'?: string;
'nextStart'?: string;
} => r.body)
    );
  }

  /** Path part for operation `taxIdMappingRulesPost()` */
  static readonly TaxIdMappingRulesPostPath = '/tax-id-mapping-rules';

  /**
   * Creates a tax ID mapping rule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxIdMappingRulesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxIdMappingRulesPost$Response(params: TaxIdMappingRulesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>> {
    return taxIdMappingRulesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a tax ID mapping rule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxIdMappingRulesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxIdMappingRulesPost(params: TaxIdMappingRulesPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & TaxIdMappingRule> {
    return this.taxIdMappingRulesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>): {
'_links'?: HalJson;
} & TaxIdMappingRule => r.body)
    );
  }

  /** Path part for operation `taxIdMappingRulesIdGet()` */
  static readonly TaxIdMappingRulesIdGetPath = '/tax-id-mapping-rules/{id}';

  /**
   * Gets a tax ID mapping rule by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxIdMappingRulesIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesIdGet$Response(params: TaxIdMappingRulesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>> {
    return taxIdMappingRulesIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a tax ID mapping rule by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxIdMappingRulesIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesIdGet(params: TaxIdMappingRulesIdGet$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & TaxIdMappingRule> {
    return this.taxIdMappingRulesIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>): {
'_links'?: HalJson;
} & TaxIdMappingRule => r.body)
    );
  }

  /** Path part for operation `taxIdMappingRulesIdPut()` */
  static readonly TaxIdMappingRulesIdPutPath = '/tax-id-mapping-rules/{id}';

  /**
   * Updates a tax ID mapping rule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxIdMappingRulesIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxIdMappingRulesIdPut$Response(params: TaxIdMappingRulesIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>> {
    return taxIdMappingRulesIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a tax ID mapping rule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxIdMappingRulesIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxIdMappingRulesIdPut(params: TaxIdMappingRulesIdPut$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & TaxIdMappingRule> {
    return this.taxIdMappingRulesIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>): {
'_links'?: HalJson;
} & TaxIdMappingRule => r.body)
    );
  }

  /** Path part for operation `taxIdMappingRulesIdDelete()` */
  static readonly TaxIdMappingRulesIdDeletePath = '/tax-id-mapping-rules/{id}';

  /**
   * Deletes a tax ID mapping rule.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxIdMappingRulesIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesIdDelete$Response(params: TaxIdMappingRulesIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return taxIdMappingRulesIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a tax ID mapping rule.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxIdMappingRulesIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxIdMappingRulesIdDelete(params: TaxIdMappingRulesIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.taxIdMappingRulesIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
